import dayjs from 'dayjs'

const WEEKDAYS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']

const parseDateValue = (value: unknown) => {
  if (!value) return null
  const text = String(value).trim()
  const dmy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(text)
  if (dmy) {
    const parsed = dayjs(`${dmy[3]}-${dmy[2]}-${dmy[1]}`)
    return parsed.isValid() ? parsed : null
  }
  const parsed = dayjs(text)
  return parsed.isValid() ? parsed : null
}

const dayOfWeekFromValue = (value: unknown) => {
  if (!value) return ''
  const parsed = parseDateValue(value)
  if (!parsed) return ''
  // Use UTC or local day based on string
  const text = String(value).trim()
  if (text.includes('Z')) {
    const date = new Date(text)
    return Number.isNaN(date.getTime()) ? '' : WEEKDAYS[date.getUTCDay()]
  }
  return WEEKDAYS[parsed.day()]
}

export const getTableFilterValue = (row: any, field: string): unknown => {
  if (field === 'dayOfWeek') {
    return row?.dayOfWeek || dayOfWeekFromValue(row?.timestamp ?? row?.date ?? row?.period)
  }
  if (field === 'period' || field === 'periodRange') {
    return row?.periodRange ?? row?.period
  }
  if (field === 'meterNumber' || field === 'meterId' || field === 'id') {
    return row?.meterNumber ?? row?.meterId ?? row?.id
  }
  if (field === 'name' || field === 'consumerName') {
    return row?.name ?? row?.consumerName
  }
  if (field === 'activity' || field === 'activityType') {
    return row?.activity ?? row?.activityType
  }
  if (field === 'activityDescription' || field === 'description') {
    return row?.activityDescription ?? row?.description
  }

  const directValue = row?.[field]
  if (Array.isArray(directValue)) {
    if (directValue.length === 0) return ''
    if (directValue.length === 1) return directValue[0]
    return directValue.map(v => (typeof v === 'object' && v?.name ? v.name : String(v))).join(', ')
  }
  if (directValue != null && directValue !== '') return directValue
  return directValue
}

export const normalizeTableFilterValue = (value: unknown) =>
  String(value ?? '').trim().toLocaleLowerCase('he-IL')

export const parseTableDate = (value: unknown): number | null => {
  if (value == null || value === '') return null
  if (value instanceof Date) {
    return Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())
  }
  const text = String(value).trim()
  const dmy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(text)
  if (dmy) {
    return Date.UTC(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]))
  }
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text)
  if (dateOnly) {
    return Date.UTC(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
  }
  const d = dayjs(text)
  if (d.isValid()) {
    return Date.UTC(d.year(), d.month(), d.date())
  }
  const parsed = new Date(text).getTime()
  return Number.isNaN(parsed) ? null : parsed
}
